import React from 'react';
import PropTypes from 'prop-types';
import {transformedRideDataFromArticleWidget} from "../../../HorseRacing/utils";
import HorseRacingRacecardRunner from "../../../HorseRacing/components/HorseRacingRacecardRunner";
import SkyBetLogo from "../../../Common/components/svg/SkyBetLogo";
import {connect} from "react-redux";
import {get} from "lodash";
import withErrorBoundary from "../../../Errors/components/withErrorBoundry";

export class RacerunnerWidget extends React.PureComponent {
  state = {
    show: false
  }

  toggleFormExpanded = (runnerId) => {
    const newValue = this.state.show === runnerId ? null : runnerId;
    this.setState({show: newValue});
  };

  render() {
    const {widget, races} = this.props;
    const cardProps = transformedRideDataFromArticleWidget(widget, races);
    const showExpandedForm = cardProps && (this.state.show === cardProps.runner.key);

    if (!cardProps) {
      return null;
    }

    return (
      <div className={`news-article-body-race-runner-${showExpandedForm ? "showing" : "no"}-video`}>
        <HorseRacingRacecardRunner
          embedded
          showExpandedForm={showExpandedForm}
          toggleFormExpanded={this.toggleFormExpanded}
          {...cardProps}
        />
        {cardProps.eventRef && (
          <div className="news-article-body-race-runner-skybet">
            <span className="news-article-body-race-runner-skybet-text">Live betting powered by</span>
            <SkyBetLogo/>
          </div>
        )}
      </div>
    )
  }
}

RacerunnerWidget.mapProps = (props) => ({
  widget: props.widget,
})
RacerunnerWidget.propTypes = {
  widget: PropTypes.object,
  races: PropTypes.array
}


const mapStateToProps = state => {
  const races = get(state, 'horseRacing.rides.races', []);

  return {
    races
  };
}
export default withErrorBoundary(connect(mapStateToProps)(RacerunnerWidget));



// WEBPACK FOOTER //
// ./modules/News/components/widgets/Racerunner.widget.js